<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important">
  <div class="d-flex justify-content-between" style="margin: 0">
    <div style="width: 98%;word-break: break-word;">
      <span>{{ "title.document_storage" | translate }}</span>
    </div>
    <div>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div *ngIf="!isMultiUser || !isAdminDefault">
    <ng-container *ngTemplateOutlet="tmlpList; context:systemTmlp"></ng-container>
  </div>
  <mat-tab-group class="matTab" (selectedTabChange)="onTabChanged($event)" [(selectedIndex)]="currentTab" *ngIf="isMultiUser && isAdminDefault">
    <mat-tab>
      <ng-template mat-tab-label>
        <span [ngClass]="currentTab == 0 ? 'text-primary' : ''">{{'title.system_template'| translate}}</span>
      </ng-template>
      <ng-container *ngTemplateOutlet="tmlpList; context:systemTmlp"></ng-container>
    </mat-tab>
    <mat-tab *ngIf="isBuyTwoService">
      <ng-template mat-tab-label>
        <span [ngClass]="currentTab == 1 ? 'text-primary' : ''">{{'title.template_from' | translate}} {{syncAccount}}</span>
      </ng-template>
      <ng-container *ngTemplateOutlet="tmlpList; context:syncTmlp"></ng-container>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<div mat-dialog-actions class="justify-content-center mt-2">
  <button mat-stroked-button color="primary" (click)="close()">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{ "document_download.cancel" | translate }}
  </button>
</div>

<ng-template #tmlpList let-templateList>
  <form [formGroup]="templateList.formGroup" class="w-100" (submit)="search()">
    <div class="row mt-3" style="font-size: 16px;">
      <div [ngClass]="{'col-10': !templateList.formGroup.get('realm'), 'col-5': templateList.formGroup.get('realm')}">
        <!-- ten/ ma mau-->
        <mat-form-field class="w-100">
          <input #focusInput matInput type="text" [placeholder]="'document_download.placeholder_name' | translate"
            name="documentName" maxlength="200" autocomplete="off" formControlName="name" (keydown.enter)="search()" />
          <button mat-button *ngIf="templateList.formGroup?.controls?.name?.value" type="button" matSuffix
            mat-icon-button aria-label="Clear" (click)="clearData('name')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="col-5" *ngIf="templateList.formGroup.get('realm')">
        <!-- loai hop dong -->
        <mat-form-field class="w-100">
          <mat-select id="type" name="type" [placeholder]="'document_download.placeholder_type' | translate"
            formControlName="realm" (selectionChange)="onRealmChange($event)">
            <mat-option [value]="">
              {{"document_download.select_all" | translate}}
            </mat-option>
            <mat-option *ngFor="let realm of listRealmOptions" [value]="realm.id">
              {{realm.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-2 pt-3">
        <button mat-stroked-button color="primary" type="submit" style="width: 100%;">
          <mat-icon class="mr-0" style="font-weight: 900">search</mat-icon>
          {{ "search_form.search" | translate }}
        </button>
      </div>
    </div>
  </form>
  <div class="mat-panel-title">{{"title.document_type_list2" | translate}}({{total}})</div>
  <div class="list-template overflow-y-auto overflow-x-hidden">
    <mat-card *ngFor="let data of templateList.list; let i = index"
      style="padding: 0 .25rem !important; min-width: 12rem;">
      <div style="width: 100%; border: 1px solid rgb(185, 185, 185);
                border-radius: 5px; height: 23rem; background: #e6e6e6 !important;">
        <div style="margin: 1rem auto; width: 80%; height: 100%; overflow: hidden;">
          <div style="width: 100%; height: 64%; border: 1px solid gray; margin-bottom: 1rem; background: white;">
            <!-- <img [src]="imageUrl" alt="" style="width: 100%"> -->
            <img *ngIf="image[data.id]" [src]="image[data.id]" style="width: 100%; height: 100%">
          </div>
          <span [matTooltip]="renderRealm(data.realm)" *ngIf="templateList.formGroup.get('realm')"
            class="fix-width d-inline-block font-weight-bold">{{renderRealm(data.realm)}}</span>
          <br *ngIf="templateList.formGroup.get('realm')" />
          <span [matTooltip]="data.name" style="overflow: hidden;
                        max-width: 80%;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        display: inline-block;">{{data.name}}</span>
          <mat-icon class="ml-1 text-danger" [matTooltip]="'document_template.tooltip_preview' | translate"
            style="cursor: pointer;" (click)="preview(data)">visibility
          </mat-icon>
          <div class="w-100 text-center mt-1">
            <button mat-stroked-button style="background: white;" color="primary" type="submit"
              (click)="templateList.formGroup.get('realm') ? downloadTemplate(data) : copyTemplate(data)">
              <mat-icon class="mr-0" style="font-weight: 900">save_alt</mat-icon>
              {{ "document_download.download" | translate }}
            </button>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <div>
    <app-pagination [(paginate)]="templateList.paginate" [isShowChangeRecordOfPage]="isShowChangeRecordOfPage"
      (pageChange)="onFilterData($event.page)">
    </app-pagination>
  </div>
</ng-template>